// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"539": "7be9393a","955": "72aec291",}[chunkId] + ".css"
}